import { render, staticRenderFns } from "./PortfolioWidget.vue?vue&type=template&id=6cf95b88&scoped=true&"
import script from "./PortfolioWidget.vue?vue&type=script&lang=js&"
export * from "./PortfolioWidget.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioWidget.vue?vue&type=style&index=0&id=6cf95b88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf95b88",
  null
  
)

export default component.exports